<div class="add-filter-modal">
    <aside class="add-filter-modal__menu">
        <app-sidemenu [nodes]="menuItems" [selectedNodeId]="selectedMenuId" (nodeSelect)="onMenuSelected($event)">
        </app-sidemenu>
    </aside>

    <section class="add-filter-modal__content">
        <div [hidden]="selectedMenuId !== 'ask'" class="add-filter-modal__pane">
            <app-ask-panel
                title="What filter would you like to add?"
                description="Use plain language. You can review the result in Visual Editor."
                placeholder="Add a multi-select dropdown to filter on Application PADU field"
                helperText="ASK will create the filter label, map the data column, and select the best control type."
                [(value)]="askPromptValue">
            </app-ask-panel>
        </div>

        <div [hidden]="selectedMenuId !== 'visual-editor'" class="add-filter-modal__pane">
            <app-add-filter [draft]="filterDraft" (draftChange)="onFilterDraftChange($event)"></app-add-filter>
        </div>

        <div [hidden]="selectedMenuId !== 'json-editor'" class="add-filter-modal__pane">
            <app-json-editor [initialJson]="jsonEditorInitialJson" jsonType="filter"
                (jsonTextChange)="onJsonTextChange($event)">
            </app-json-editor>
        </div>

        <div [hidden]="selectedMenuId !== 'sql-query'" class="add-filter-modal__pane add-filter-modal__pane--full">
            <app-visual-code [currentQuery]="sqlQueryCode" [constructedQuery]="sqlQueryCode"></app-visual-code>
        </div>
    </section>
</div>
